if (!customElements.get('product-gallery')) {
  class ProductGallery extends HTMLElement {
    async connectedCallback() {
      this.main = this.querySelector('[data-gallery-main]');
      this.thumbs = this.querySelector('[data-gallery-thumbs]');
      this.activeVideoSlide = null;
      if (!this.main) return;

      this.onSlideChange = () => this.syncToActive_();
      this.main.addEventListener('swiperslidechange', this.onSlideChange);

      this.onVariantChange = (e) => {
        if (String(e.detail?.productId) !== this.dataset.productId) return;
        this.swapVariantImage_(e.detail.variant?.featured_image);
      };
      window.addEventListener('product-form:variant-change', this.onVariantChange);

      await customElements.whenDefined('swiper-container');

      this.thumbs?.initialize();
      this.main.initialize();

      [this.thumbs, this.main].forEach((el) => {
        if (!el) return;
        el.setAttribute('data-ready', '');
        el.swiper?.update();
      });

      if (this.main.swiper) this.syncToActive_();
    }

    syncToActive_() {
      const swiper = this.main.swiper;
      if (!swiper) return;

      const index = swiper.activeIndex;
      this.querySelectorAll('[data-gallery-thumb]').forEach((el, i) => el.classList.toggle('active', i === index));

      const slide = swiper.slides[index];
      if (slide?.dataset.galleryVideoId) {
        this.showVideo_(slide);
      } else {
        this.clearVideo_();
      }
    }

    swapVariantImage_(image) {
      const index = Number(this.dataset.variantSlotIndex);
      if (!image?.src || !(index >= 0)) return;

      const sized = (width) => `${image.src}${image.src.includes('?') ? '&' : '?'}width=${width}`;
      const fileName = (src) => src.split('?')[0].split('/').pop();

      const mainImg = this.main.querySelectorAll(':scope > swiper-slide')[index]?.querySelector('img');
      const thumbImg = this.querySelectorAll('[data-gallery-thumb]')[index]?.querySelector('img');

      if (mainImg && fileName(mainImg.currentSrc || mainImg.src) !== fileName(image.src)) {
        mainImg.srcset = [400, 600, 800, 1200].map((w) => `${sized(w)} ${w}w`).join(', ');
        mainImg.src = sized(1200);
        mainImg.alt = image.alt || '';
      }
      if (thumbImg) {
        thumbImg.removeAttribute('srcset');
        thumbImg.src = sized(200);
      }

      this.main.swiper?.slideTo(index);
    }

    showVideo_(slide) {
      if (this.activeVideoSlide === slide) return;

      const stage = slide.querySelector('[data-gallery-video-stage]');
      const template = slide.querySelector(`[data-gallery-video="${slide.dataset.galleryVideoId}"]`);
      if (!stage || !template) return;

      this.clearVideo_();
      stage.appendChild(template.content.cloneNode(true));
      this.activeVideoSlide = slide;
      slide.querySelector('[data-gallery-poster]')?.setAttribute('aria-hidden', 'true');
    }

    clearVideo_() {
      const slide = this.activeVideoSlide;
      if (!slide) return;

      const stage = slide.querySelector('[data-gallery-video-stage]');
      if (stage) {
        stage.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
          video.load();
        });
        stage.querySelectorAll('iframe').forEach((frame) => {
          frame.src = 'about:blank';
        });
        stage.replaceChildren();
      }

      slide.querySelector('[data-gallery-poster]')?.removeAttribute('aria-hidden');
      this.activeVideoSlide = null;
    }

    disconnectedCallback() {
      this.clearVideo_();
      this.main?.removeEventListener('swiperslidechange', this.onSlideChange);
      window.removeEventListener('product-form:variant-change', this.onVariantChange);
    }
  }

  customElements.define('product-gallery', ProductGallery);
}
